// query-keys/job-keys.js
import { queryClient } from "utils/react-query";

const collection = "jobs";

export const jobKeys = {
  // Base keys
  all: () => [collection],
  details: () => [...jobKeys.all(), "detail"],
  detail: (id) => [...jobKeys.details(), id],
  list: () => [collection, "list"],

  // Status-specific queries
  byStatus: (status) => [...jobKeys.all(), "status", status],

  // Project-related job queries
  byProject: (projectId) => [...jobKeys.all(), "project", projectId],

  // Milestone-related queries
  milestones: (jobId) => [...jobKeys.detail(jobId), "milestones"],
  milestoneCount: (jobId) => [...jobKeys.detail(jobId), "milestone-count"],

  // Search/filter queries
  search: (query) => [...jobKeys.all(), "search", query],

  // Dashboard/stats queries
  stats: () => [...jobKeys.all(), "stats"],
  recent: () => [...jobKeys.all(), "recent"],
};

export function invalidateJobQueries(jobId) {
  const predicates = [
    // Invalidate all job lists
    ({ queryKey }) => queryKey[0] === collection,
    ({ queryKey }) => queryKey[0] === "projects" && queryKey[1] === "list",

    // // Invalidate specific job detail and related queries
    // ({ queryKey }) =>
    //   queryKey[0] === collection &&
    //   queryKey[1] === "detail" &&
    //   queryKey[2] === jobId,

    // // Invalidate job stats and recent jobs
    // ({ queryKey }) =>
    //   queryKey[0] === collection &&
    //   (queryKey[1] === "stats" || queryKey[1] === "recent"),

    // // Invalidate any project-related job queries
    // ({ queryKey }) => queryKey[0] === collection && queryKey[1] === "project",

    // // Invalidate search results
    // ({ queryKey }) => queryKey[0] === collection && queryKey[1] === "search",

    // // Invalidate milestone-related queries for this job
    // ({ queryKey }) =>
    //   queryKey[0] === collection &&
    //   queryKey[1] === "detail" &&
    //   queryKey[2] === jobId &&
    //   (queryKey[3] === "milestones" || queryKey[3] === "milestone-count"),
  ];

  predicates.forEach((predicate) => {
    queryClient.invalidateQueries({ predicate });
  });
}

// Additional helper for invalidating all job queries
export function invalidateAllJobQueries() {
  queryClient.invalidateQueries({
    predicate: ({ queryKey }) => queryKey[0] === collection,
  });
}
